<script>
import $ from '../../core/KJQuery'
import _ from 'lodash'
import URI from 'urijs'
import KImage from '../image'

export default {
  name: 'KPortrait',
  components: {},
  mixins: [
    // KRipple,
  ],
  props: {
    female: {
      // 是否是女生（当图片不存在或者加载失败，基于性别显示默认图片）
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
    defaultMaleUrl: {
      type: String,
      default: require('./portrait-boy.png'),
    },
    defaultFemaleUrl: {
      type: String,
      default: require('./portrait-girl.png'),
    },
    width: {
      type: Number,
      default: 32,
    },
    height: {
      type: Number,
      default: 32,
    },
    rounded: {
      type: Boolean,
    },
    noClip: {
      type: Boolean,
      default: false,
    },
    lazyLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      portraitError: false,
    }
  },
  computed: {
    clipWidth() {
      return this.width || ''
    },
    clipHeight() {
      return this.height || this.clipWidth
    },
    defaultUrl() {
      return this.female ? this.defaultFemaleUrl : this.defaultMaleUrl
    },
    isBase64() {
      return this.url && _.startsWith(this.url, 'data:image')
    },
    realUrl() {
      let usePropUrl = false
      let realUrl = this.defaultUrl
      if (!this.portraitError && this.url) {
        usePropUrl = true
        realUrl = this.url
      }

      if (!this.noClip && this.clipWidth && usePropUrl && !this.isBase64) {
        const clipWidth = this.clipWidth * 2
        const clipHeight = this.clipHeight * 2
        const uri = URI(realUrl)
        const urlQuery = uri.query(true)
        const resizeProcess = `resize,m_lfit,w_${clipWidth},h_${clipHeight},limit_0`
        const currentProcess = _.trim(urlQuery['x-oss-process'] || '')
        const normalizedCurrentProcess = currentProcess
          .replace(/^image\//, '')
          .replace(/^\/+|\/+$/g, '')
        const newProcess = normalizedCurrentProcess
          ? `image/${normalizedCurrentProcess}/${resizeProcess}`
          : `image/${resizeProcess}`
        realUrl = uri.setQuery(
          _.assign(urlQuery, {
            'x-oss-process': newProcess,
          })
        ).toString()
      }

      return realUrl
    },
  },
  watch: {
    url: {
      immediate: true,
      handler() {
        if (this.url && !this.lazyLoading) {
          this.loadPortrait()
        }
      },
    },
  },
  methods: {
    loadPortrait() {
      $('<img>')
        .attr({
          src: this.realUrl,
        })
        .on('error', () => {
          this.portraitError = true
        })
    },
  },
  render() {
    const portraitAttrs = {
      staticClass: 'km-portrait',
      attrs: {
        ...this.$attrs,
      },
      on: {
        ...this.$listeners,
      },
    }

    return (
      <KImage
        fit="cover"
        {...portraitAttrs}
        src={this.realUrl}
        width={this.clipWidth}
        height={this.clipHeight}
        rounded={this.rounded}
        fallback={this.defaultUrl}
        lazy-loading={this.lazyLoading}
      ></KImage>
    )
  },
  renderOld(createElement) {
    const portraitAttrs = {
      staticClass: 'km-portrait',
      class: [
        {
          'is-rounded': this.rounded,
          'km-crop__preview-item': true,
        },
      ],
      style: {
        'background-image': `url(${this.realUrl})`,
        width: this.clipWidth + 'px',
        height: this.clipHeight + 'px',
      },
      attrs: {
        ...this.$attrs,
      },
      on: {
        ...this.$listeners,
      },
    }

    let tag = 'div'
    if (this.$attrs.href) {
      tag = 'a'
      portraitAttrs.style.cursor = 'pointer'
    }
    return createElement(tag, portraitAttrs, [])
  },
}
</script>
